import { useInfiniteAssemblyApplicationsDataSource } from 'custom_hooks/data_hooks/data_source/assemblyApplicationsDataSource';
import { useDrainDataSource } from 'custom_hooks/data_hooks/data_source/useDrainDataSource';
import { useEffect, useMemo } from 'react';
import { queryClient } from 'utils/query';

const queryKey = 'assembly-applications';

export function useAssemblyApplications(assemblyTypeId: number | undefined) {
    const { results, isLoading, setFilter, refetch } = useDrainDataSource(
        useInfiniteAssemblyApplicationsDataSource({
            name: queryKey,
            defaultSort: [{ field: 'Name', dir: 'asc' }],
            defaultFilter: { assemblyTypeId },
            enabled: !!assemblyTypeId,
        })
    );

    useEffect(() => {
        setFilter((current) => ({ ...current, assemblyTypeId }));
    }, [assemblyTypeId, setFilter]);

    const finalResults = useMemo(() => (!assemblyTypeId ? [] : results), [
        assemblyTypeId,
        results,
    ]);

    return { results: finalResults, isLoading, setFilter, refetch };
}

export function invalidateAssemblyApplications() {
    queryClient.invalidateQueries({
        queryKey: [queryKey],
    });
}
